import React, { useEffect, useState } from "react";
import "./deliveryCollections.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NextArrow from "../../carousel/nextArrow";
import PrevArrow from "../../carousel/prevArrow";
import DeliveryItem from "./deliveryItem";
import axios from "axios";

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  speed: 1000,
  autoplay: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
};

const DeliveryCollections = () => {
  const [dataCollection, setDataCollection] = useState([]);

  const getIndianMeal = async () => {
    const { data } = await axios(
      "https://www.themealdb.com/api/json/v1/1/categories.php"
    );
    setDataCollection(data.categories);
  };

  useEffect(() => {
    getIndianMeal();
  }, []);

  const renderdItem = dataCollection.map((item) => {
    return <DeliveryItem item={item} key={item.idCategory} />;
  });

  return (
    <div className="delivery-collections">
      <div className="max-width">
        <div className="collection-title">Eat what makes you happy</div>
        <Slider {...settings}>{renderdItem}</Slider>
      </div>
    </div>
  );
};

export default DeliveryCollections;
